class AnalyticsOnClickController {
    constructor($element, analytics) {
        this.analytics = analytics;
        $element.on('click', () => {
            this.analytics.pushEvent(this.event);
        });
    }
}

const analyticsOnClickDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {},
    bindToController: {
        event: '@olyAnalyticsOnClick',
    },
    controller: ['$element', 'AnalyticsService', AnalyticsOnClickController],
    controllerAs: 'analyticsOnClickCtrl',
});

module.exports = {
    AnalyticsOnClickController,
    analyticsOnClickDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/analytics/analytics-on-click.directive.js